module.exports = __webpack_public_path__ + "static/media/HAI-logo-SALVUS.2c6f5bb0.png";